import { Check, CreditCard, Truck, PackageCheck, BadgeEuro } from "lucide-react";

const STEPS = [
  { key: "pending_payment", label: "Payment", icon: CreditCard },
  { key: "funds_held", label: "Payment Held", icon: BadgeEuro },
  { key: "shipped", label: "Shipped", icon: Truck },
  { key: "delivered", label: "Delivered", icon: PackageCheck },
  { key: "released", label: "Paid to Artist", icon: Check },
];

const ORDER = ["pending_payment", "funds_held", "shipped", "delivered", "released"];

export default function EscrowTimeline({ status, compact }) {
  const currentIdx = ORDER.indexOf(status);
  if (status === "cancelled") {
    return <div className="text-sm text-[var(--destructive)] font-mono">Order cancelled</div>;
  }
  return (
    <div className={`flex ${compact ? "gap-2" : "gap-0"} items-start`} data-testid="escrow-timeline">
      {STEPS.map((step, i) => {
        const done = i <= currentIdx;
        const active = i === currentIdx;
        const Icon = step.icon;
        return (
          <div key={step.key} className="flex-1 flex flex-col items-center relative">
            {i < STEPS.length - 1 && (
              <div className={`absolute top-4 left-1/2 w-full h-0.5 ${i < currentIdx ? "bg-[var(--escrow-green)]" : "bg-stone-200"}`} />
            )}
            <div className={`relative z-10 w-8 h-8 rounded-full flex items-center justify-center border-2 transition-colors ${
              done ? "bg-[var(--escrow-green)] border-[var(--escrow-green)] text-white"
                   : "bg-white border-stone-300 text-stone-400"
            } ${active ? "ring-4 ring-[var(--escrow-green-bg)]" : ""}`}>
              <Icon className="w-4 h-4" />
            </div>
            {!compact && (
              <span className={`mt-2 text-[0.68rem] text-center font-medium leading-tight ${
                done ? "text-[var(--text-primary)]" : "text-stone-400"}`}>
                {step.label}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}

export const escrowLabel = (status) => ({
  pending_payment: "Awaiting payment",
  funds_held: "Payment held — awaiting shipment",
  shipped: "In transit",
  delivered: "Delivery confirmed",
  released: "Paid to artist",
  cancelled: "Cancelled",
}[status] || status);
